import Phaser from 'phaser';
import { COLORS } from '../theme';

/**
 * Render N progress beads. `used` past entries fill yolk, current entry is coral
 * with glow, rest are faint outlines.
 */
export class ProgressBeads {
  container: Phaser.GameObjects.Container;
  private g: Phaser.GameObjects.Graphics;

  constructor(
    private scene: Phaser.Scene,
    private x: number,
    private y: number,
    private total: number,
  ) {
    this.container = scene.add.container(x, y);
    this.g = scene.add.graphics();
    this.container.add(this.g);
    this.render(0);
  }

  /** used = throws already taken; current = next bead is the "in flight" one. */
  render(used: number) {
    const g = this.g;
    g.clear();
    const beadW = 48;
    const beadH = 10;
    const gap = 12;
    const totalW = this.total * beadW + (this.total - 1) * gap;
    for (let i = 0; i < this.total; i++) {
      const bx = -totalW / 2 + i * (beadW + gap);
      let color = COLORS.white;
      let alpha = 0.16;
      if (i < used) {
        color = COLORS.yolk;
        alpha = 1;
      } else if (i === used) {
        color = COLORS.coral;
        alpha = 1;
        // glow underlay
        g.fillStyle(COLORS.coral, 0.35);
        g.fillRoundedRect(bx - 4, -beadH / 2 - 4, beadW + 8, beadH + 8, 8);
      }
      g.fillStyle(color, alpha);
      g.fillRoundedRect(bx, -beadH / 2, beadW, beadH, 5);
    }
  }

  destroy() {
    this.container.destroy();
  }
}
